import { Button } from "@/components/ui/button";
import { CheckCircle2, PhoneCall } from "lucide-react";
import { usePhoneBar } from "@/contexts/PhoneBarContext";
import roofingProject from "@/assets/roofing-project-1.jpg";

const benefits = [
  "0% interest financing options available",
  "As low as $99/month on qualifying roofs",
  "No money down — start your project today",
  "We work with all major insurance carriers",
  "Free roof inspection & detailed estimate",
];

export const AdsFinancingSection = () => {
  const { phoneNumber } = usePhoneBar();
  const formattedPhone = phoneNumber.replace("+1", "").replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");

  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div>
            <h2 className="text-3xl font-extrabold text-foreground mb-2">
              Affordable Roofing,{" "}
              <span className="text-primary">No Surprises</span>
            </h2>
            <p className="text-muted-foreground mb-6">
              We believe every Long Island homeowner deserves a safe, beautiful roof — regardless of budget. That's why we offer flexible financing with transparent pricing.
            </p>
            <ul className="space-y-3 mb-8">
              {benefits.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-primary mt-0.5 shrink-0" />
                  <span className="text-foreground">{b}</span>
                </li>
              ))}
            </ul>
            <Button size="lg" className="font-bold" onClick={() => (window.location.href = `tel:${phoneNumber}`)}>
              <PhoneCall className="w-4 h-4 mr-2" />
              Call {formattedPhone}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
